export const FORM_FIELDS = {
  NAME: 'name',
};
